import React from 'react'

const PageTitleBar: React.FC = ({ children }) => (
	<header className="page-title-bar">
      {children}
    </header>
)


export default PageTitleBar